export const administrationAccountsHeadOffices = {
    template: require('./administration-accounts-head-offices.html'),
    controller: 'AdministrationAccountsHeadOfficesController'
};
